class VehicleProducts extends HTMLElement {
  constructor() {
    super();
    this.vehicleStorage = window.vehicleStorage;
    this.dataStorage = window.storedVehicleData;
    this.hasStorageProducts = window.hasStorageProducts;

    this.parmas = new URLSearchParams(window.location.search);
    this.partTypeParam = this.parmas.get('part_type');
    this.partTypeParams = (this.partTypeParam || '').split(',').filter(Boolean);

    this.ctEl = this.querySelector('[data-filters-bar-results-count]');
    this.isCarousel = this.hasAttribute('data-is-carousel');
    this.isCarouselCollapsed = this.isCarousel && this.hasAttribute('data-hide-atc');
    this.isCarouselExpanded = this.isCarousel && this.hasAttribute('data-show-expanded-product-cards');
    this.isVLP = window.location.href.includes('/vehicle/')
    this.pageHandle = this.isVLP ? window.location.href.split('/vehicle/')[1].split('?')[0] : null;
    this.el = this.isCarousel ? this.closest('.media-cards__items') : this.querySelector('#productGrid');
    this.verified = !this.isCarousel && this.isVerifiedLandingPage();
    this.ymm = this.dataset.ymmObject ? JSON.parse(this.dataset.ymmObject) : null;
    this.parentMapPromise = this.isVLP && !this.isCarousel ? this.getParentMap() : Promise.resolve(new Map());

    if (this.partTypeParam) this.updateMeta();

    if (!this.verified && !this.isCarousel) {
      if (this.partTypeParam) this.updateVerifiedFitContent(this.partTypeParams);
      this.getYmmProducts();
    } else if (this.hasStorageProducts) {
      this.updateVerifiedFitContent();
      this.getVerifiedProducts();
    }
  }

  async fetchCard(handle) {
    const carouselSectionId = this.isCarouselCollapsed ? 'product-card-verified-carousel--collapsed' : this.isCarouselExpanded ? 'product-card-verified-carousel--expanded' : 'product-card-verified-carousel';
    const sectionId = this.isCarousel ? carouselSectionId : this.verified ? 'product-card-verified' :  'product-card';
    const response = await fetch(`${routes.root_url}products/${handle}?section_id=${sectionId}`);
    return response.ok ? response.text() : null;
  }

  getHTML(responseText, product) {
    const { fitmentNotes, position, quantity } = this.fitmentOf(product);

    if (fitmentNotes?.length) {
      responseText = responseText.replace('{{fitmentNotes}}', window.renderFitmentNotes(fitmentNotes));
    }

    if (position) {
      responseText = responseText.replace('<dd data-product-card-attr-value="Position" class="product-card__attribute-value"></dd>', `<dd data-product-card-attr-value="Position" class="product-card__attribute-value">${position}</dd>`);
    }

    if (quantity) {
      responseText = responseText.replace('<dd data-product-card-attr-value="Quantity Per Vehicle" class="product-card__attribute-value"></dd>', `<dd data-product-card-attr-value="Quantity Per Vehicle" class="product-card__attribute-value">${quantity}</dd>`);
    }

    if (fitmentNotes?.length || position || quantity) {
      responseText = responseText.replace('class="product-card', 'data-is-verified="true" class="product-card');
    }

    const parser = new DOMParser().parseFromString(responseText, 'text/html');
    return parser.querySelector('.shopify-section').innerHTML;
  }

  fitmentOf(product) {
    const storageProduct = this.hasStorageProducts ? this.vehicleStorage.products.find(p => p.handle === product.handle) : null;
    return {
      fitmentNotes: product.fitmentNotes || storageProduct?.fitmentNotes,
      position: product.position || storageProduct?.position,
      quantity: product.quantity || storageProduct?.quantity,
    };
  }

  async getParentMap() {
    const handle = window.ymmConfig?.combinedListingParentsCollection || 'all';
    const cacheKey = `combinedListingParents:v3:${handle}`;
    const toMap = entries => {
      this.defaultChildren = new Set(entries.filter(entry => entry[2] === 'default').map(entry => entry[0]));
      return new Map(entries.map(([child, parent]) => [child, parent]));
    };
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey));
      if (cached && Date.now() - cached.time < 60 * 60 * 1000) return toMap(cached.entries);
    } catch (e) {}

    const fetchPage = async page => {
      const response = await fetch(`${routes.root_url}collections/${handle}?section_id=combined-listing-parents&page=${page}`);
      if (!response.ok) throw new Error(`Combined Listing parents page ${page} returned ${response.status}`);
      const el = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-combined-listing-parents]');
      const entries = (el?.textContent || '').split('\n').map(line => line.trim().split(/\s+/)).filter(entry => entry.length >= 2);
      return { pages: Number(el?.dataset.pages) || 1, entries };
    };

    try {
      const first = await fetchPage(1);
      const rest = await Promise.all(Array.from({ length: first.pages - 1 }, (_, index) => fetchPage(index + 2)));
      const entries = [first, ...rest].flatMap(page => page.entries);
      try {
        sessionStorage.setItem(cacheKey, JSON.stringify({ time: Date.now(), entries }));
      } catch (e) {}
      return toMap(entries);
    } catch (e) {
      console.error('Failed to load Combined Listing parents', e);
      return new Map();
    }
  }

  groupByParent(products, parentMap) {
    const groups = new Map();
    const entries = [];

    const parentHandles = new Set(parentMap.values());

    products.forEach(product => {
      const parentHandle = parentMap.get(product.handle);
      if (!parentHandle) {
        if (!parentHandles.has(product.handle)) entries.push({ card: product, children: [product] });
        return;
      }
      if (!groups.has(parentHandle)) {
        const entry = { card: product, children: [], parentHandle };
        groups.set(parentHandle, entry);
        entries.push(entry);
      }
      groups.get(parentHandle).children.push(product);
    });

    groups.forEach(entry => {
      entry.card = entry.children.find(child => this.defaultChildren?.has(child.handle)) || entry.card;
    });

    return entries;
  }

  async mergeLeftoverChildren(entries, parentMap) {
    const groups = new Map(entries.filter(entry => entry.parentHandle).map(entry => [entry.parentHandle, entry]));
    const known = new Map(parentMap);
    const raws = new Map(entries.map(entry => [entry.card.handle, entry.raw]));
    entries.forEach(entry => {
      entry.siblings = (entry.raw?.match(/data-combined-listing-siblings="([^"]*)"/)?.[1] || '').split(' ').filter(Boolean);
    });

    let changed = true;
    while (changed) {
      changed = false;
      entries.forEach(entry => {
        if (entry.parentHandle || entry.merged || !entry.siblings.length) return;
        const parentHandle = entry.siblings.map(handle => known.get(handle)).find(Boolean);
        if (!parentHandle) return;

        changed = true;
        known.set(entry.card.handle, parentHandle);
        const group = groups.get(parentHandle);
        if (group && entries.indexOf(entry) < entries.indexOf(group)) {
          Object.assign(entry, { parentHandle, parentRaw: group.parentRaw, children: [entry.card, ...group.children] });
          group.merged = true;
          groups.set(parentHandle, entry);
          return;
        }
        if (group) {
          group.children.push(entry.card);
          entry.merged = true;
          return;
        }
        entry.parentHandle = parentHandle;
        groups.set(parentHandle, entry);
      });
    }

    const cards = entries.filter(entry => !entry.merged);
    cards.forEach(entry => {
      const preferred = entry.parentHandle && entry.children.find(child => this.defaultChildren?.has(child.handle) && raws.get(child.handle));
      if (preferred) Object.assign(entry, { card: preferred, raw: raws.get(preferred.handle) });
    });
    await Promise.all(cards.filter(entry => entry.parentHandle && !entry.parentRaw).map(async entry => {
      entry.parentRaw = await this.fetchCard(entry.parentHandle);
    }));
    return cards;
  }

  hydrateFromParent(cardEl, parentRaw) {
    const parentEl = new DOMParser().parseFromString(parentRaw, 'text/html').querySelector('[data-product-card]');
    if (!parentEl) return;

    const titleEl = cardEl.querySelector('[data-product-card-url]');
    const parentTitleEl = parentEl.querySelector('[data-product-card-url]');
    if (titleEl && parentTitleEl) {
      titleEl.innerHTML = parentTitleEl.innerHTML;
      titleEl.title = parentTitleEl.title;
    }

    const learnMoreEl = cardEl.querySelector('.product-card__learn-more');
    const parentLearnMoreEl = parentEl.querySelector('.product-card__learn-more');
    if (learnMoreEl && parentLearnMoreEl) {
      learnMoreEl.innerHTML = parentLearnMoreEl.innerHTML;
    }

    ['name', 'image'].forEach(prop => {
      const metaEl = cardEl.querySelector(`meta[itemprop="${prop}"]`);
      const parentMetaEl = parentEl.querySelector(`meta[itemprop="${prop}"]`);
      if (metaEl && parentMetaEl) metaEl.content = parentMetaEl.content;
    });

    const mediaEl = cardEl.querySelector('[data-product-card-media]');
    const parentMediaEls = parentEl.querySelectorAll('[data-product-card-media] > .product-card__media');
    if (mediaEl && parentMediaEls.length) {
      const mediaEls = mediaEl.querySelectorAll(':scope > .product-card__media');
      parentMediaEls.forEach(el => mediaEl.insertBefore(el, mediaEls[0] || null));
      mediaEls.forEach(el => el.remove());
      cardEl.classList.toggle('product-card--has-hover-image', parentEl.classList.contains('product-card--has-hover-image'));
    }

    const skuEl = cardEl.querySelector('.product-card__sku');
    if (skuEl) skuEl.style.visibility = 'hidden';
  }

  groupRecordProduct(entry) {
    const prices = entry.children.map(child => Number(child?.priceRange?.minVariantPrice?.amount)).filter(Number.isFinite);
    return {
      ...entry.card,
      title: null,
      availableForSale: entry.children.some(child => child.availableForSale !== false),
      priceRange: { minVariantPrice: { amount: prices.length ? Math.min(...prices) : null } },
    };
  }

  updatePriceRange(cardEl, children) {
    const priceEl = cardEl.querySelector('[data-product-card-price-regular]');
    const mins = children.map(child => Number(child?.priceRange?.minVariantPrice?.amount)).filter(Number.isFinite);
    const maxes = children.map(child => Number(child?.priceRange?.maxVariantPrice?.amount)).filter(Number.isFinite);
    if (!priceEl || !mins.length) return;

    const min = Math.min(...mins);
    const max = Math.max(min, ...maxes);
    priceEl.textContent = min === max ? this.formatPrice(min) : `${this.formatPrice(min)} – ${this.formatPrice(max)}`;
    cardEl.querySelector('[data-product-card-price-compare]')?.classList.add('hide');
    cardEl.querySelector('[data-product-card-price-savings]')?.classList.add('hide');
  }

  formatPrice(amount) {
    const value = amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace('.00', '');
    return (window.theme?.moneyFormat || '${{amount}}').replace(/{{\s*\w+\s*}}/, value);
  }

  customFacetIdentifiers() {
    const builtins = ['part_type', 'sub_brand_name', 'availability', 'price', 'vendor', 'tags'];
    const facets = (window.vehicleSortConfig && window.vehicleSortConfig.facets) || [];
    const seen = new Set();
    const identifiers = [];

    facets.forEach(facet => {
      const source = String((facet && facet.source) || '').trim().toLowerCase();
      if (!source || builtins.includes(source)) return;
      if (!/^[a-z0-9_-]+(\.[a-z0-9_-]+)?$/.test(source)) return;

      const dot = source.indexOf('.');
      const namespace = dot === -1 ? 'pdm' : source.slice(0, dot);
      const key = dot === -1 ? source : source.slice(dot + 1);
      const id = `${namespace}.${key}`;
      if (seen.has(id)) return;

      seen.add(id);
      identifiers.push({ namespace, key });
    });

    return identifiers;
  }

  /*
    Get all products for unverified VLP, we only need handles to fetch the product cards
  */
  async getProducts() {
    const { year, make, model } = this.ymm;
    const identifiers = this.customFacetIdentifiers();
    const metafieldsField = identifiers.length
      ? `metafields(identifiers: [${identifiers
          .map(item => `{namespace: "${item.namespace}", key: "${item.key}"}`)
          .join(', ')}]) { namespace key value }`
      : '';
    const query = `
      query products($query: String!) {
        products(query: $query, first: 250) {
          nodes {
            handle
            title
            vendor
            tags
            createdAt
            availableForSale
            priceRange {
              minVariantPrice {
                amount
              }
              maxVariantPrice {
                amount
              }
            }
            partType:metafield(namespace: "pdm", key:"part_Type") {
              value
            }
            subBrandName:metafield(namespace: "pdm", key:"sub_brand_name") {
              value
            }
            ${metafieldsField}
            productType
            applications:metafield(namespace: "pdm", key:"applications") {
              value
            }
            applications_2:metafield(namespace: "pdm", key:"applications_2") {
              value
            }
            applications_3:metafield(namespace: "pdm", key:"applications_3") {
              value
            }
            applications_4:metafield(namespace: "pdm", key:"applications_4") {
              value
            }
            applications_5:metafield(namespace: "pdm", key:"applications_5") {
              value
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    `
    const appKeys = ['applications', 'applications_2', 'applications_3', 'applications_4', 'applications_5']
    const variables = {'query': `tag:'${year}:${make}:${model}' OR (tag:'many-applications' AND tag:'year:${year}' AND tag:'make:${make}')`};
    const response = await this.runQuery(query, variables);
    const products = response.data.products.nodes.map(product => {
      const applications = []
      appKeys.forEach(key => {
        if(product?.[key]?.value) {
          try {
            const appJson = JSON.parse(product[key].value).filter(app => {
              return String(app?.years?.[0]) === year && String(app?.make?.value) === make && String(app?.model?.value) === model
            })
            applications.push(...appJson)
          } catch(e) {
            console.error(`Failed to parse ${key} json`, e)
          }
        }
        // Get rid of the extra application data to save
        // memory since it is set with the matching applications below
        delete product?.[key]
      })
      product.applications = applications
      return product
    }).filter(app => app.applications.length > 0)
    return products;
  }

  /*
    Get all products that match Year Make Model (Unverified Vehicle Landing Page)
  */
  async getYmmProducts() {
    const products = await this.getProducts();
    this.renderProductCards(products);
  }

  async getVerifiedProducts() {
    const stored = this.vehicleStorage.products || [];

    let byHandle = new Map();
    try {
      const all = await this.getProducts();
      byHandle = new Map(all.map(product => [product.handle, product]));
    } catch (e) {
      console.error('Failed to load Storefront data for verified VLP', e);
    }

    const merged = stored.map(product => Object.assign({}, byHandle.get(product.handle) || {}, product));
    this.renderProductCards(merged);
  }

  getVehicleData(key) {
    return this.dataStorage ? this.dataStorage.options.find(item => item.key === key) : null;
  }

  getVehicleDataValue(key) {
    const option = this.getVehicleData(key);
    return option ? option.value : null;
  }

  /*
    Check if vehicle landing page matches vehicle in storage (Verified Vehicle Landing Page)
  */
  isVerifiedLandingPage() {
    return this.vehicleStorage && this.vehicleStorage.hasOwnProperty('handle') && this.vehicleStorage.handle && this.vehicleStorage.handle.split('?')[0] === this.pageHandle;
  }

  isUnverifiedPartPage() {
    return !this.verified && this.partTypeParam;
  }

  toRecord(product, el) {
    const price = Number(product?.priceRange?.minVariantPrice?.amount);
    const metafields = {};
    (product?.metafields || []).forEach(field => {
      if (field && field.key) metafields[`${field.namespace || 'pdm'}.${field.key}`] = field.value;
    });
    return {
      el,
      handle: product.handle,
      title: product.title || el.querySelector('[data-product-card-title]')?.textContent?.trim() || product.handle,
      partType: product.productType || '',
      pdmPartType: product?.partType?.value || '',
      subBrandName: product?.subBrandName?.value || '',
      available: product.availableForSale !== false,
      vendor: product.vendor || '',
      tags: Array.isArray(product.tags) ? product.tags : [],
      createdAt: Date.parse(product.createdAt) || 0,
      metafields,
      price: Number.isFinite(price) ? price : 0,
    };
  }

  stampFacetData(el, record) {
    el.dataset.facetPartType = window.handleizeFacet(record.partType);
    el.dataset.facetSubBrandName = window.handleizeFacet(record.subBrandName);
    el.dataset.facetAvailability = record.available ? 'in-stock' : 'out-of-stock';
    el.dataset.facetPrice = record.price;
    el.dataset.facetCreated = record.createdAt;
    el.dataset.facetVendor = window.handleizeFacet(record.vendor);
    Object.keys(record.metafields || {}).forEach(id => {
      el.setAttribute(`data-facet-${id.replace(/[._]/g, '-')}`, window.handleizeFacet(record.metafields[id]));
    });
  }

  renderProductCards(products) {
    this.parentMapPromise
      .then(async parentMap => {
        const entries = this.groupByParent(products, parentMap);
        await Promise.all(entries.map(async entry => {
          [entry.raw, entry.parentRaw] = await Promise.all([this.fetchCard(entry.card.handle), entry.parentHandle ? this.fetchCard(entry.parentHandle) : null]);
        }));
        return this.mergeLeftoverChildren(entries, parentMap);
      })
      .then(entries => {
        const fragment = document.createDocumentFragment();
        const records = [];

        entries.forEach(entry => {
          if (!entry.raw) return;
          const holder = document.createElement('div');
          holder.innerHTML = this.getHTML(entry.raw, entry.card);
          const cardEl = holder.querySelector('[data-product-card]');
          if (!cardEl) return;

          /* Carousel sections wrap the card in a .swiper-slide, so move the outermost element and keep that wrapper */
          let rootEl = cardEl;
          while (rootEl.parentNode && rootEl.parentNode !== holder) rootEl = rootEl.parentNode;

          Array.from(holder.children).forEach(child => {
            if (child !== rootEl && (child.tagName === 'STYLE' || child.tagName === 'SCRIPT')) fragment.appendChild(child);
          });

          if (entry.parentHandle) {
            if (entry.parentRaw) this.hydrateFromParent(cardEl, entry.parentRaw);
            this.updatePriceRange(cardEl, entry.children);
          }

          const record = this.toRecord(entry.parentHandle ? this.groupRecordProduct(entry) : entry.card, rootEl);
          /* Facets never run on carousels, and the carousel block does not load vehicle-facets.js */
          if (!this.isCarousel) this.stampFacetData(cardEl, record);
          fragment.appendChild(rootEl);
          records.push(record);
        });

        this.el.innerHTML = '';
        this.el.appendChild(fragment);
        this.records = records;
        this.updateResultsCount(records.length);
        this.renderedCallback();
        this.initFacets(records);
      })
      .catch(e => {
        console.error(e);
        document.querySelector('[data-visual-filters]')?.classList.remove('visual-filters--loading');
      });

  }

  initFacets(records) {
    const visualFilterEl = document.querySelector('[data-visual-filters]');

    if (this.isCarousel || !window.VehicleFacets) {
      visualFilterEl?.classList.remove('visual-filters--loading');
      this.applyPartTypeParam();
      return;
    }
    if (!records.length) {
      visualFilterEl?.setAttribute('hidden', '');
      return;
    }

    this.facets = new window.VehicleFacets({
      container: this.querySelector('[data-filters-container]'),
      grid: this.el,
      records,
    });
  }

  /*
    VehicleFacets honours ?part_type= through its own filter state; this covers the cases where it never runs
  */
  applyPartTypeParam() {
    if (!this.partTypeParam) return;
    const wanted = this.partTypeParam.split(',').filter(Boolean);

    this.el.querySelectorAll('[data-product-card]').forEach(cardEl => {
      let rootEl = cardEl;
      while (rootEl.parentNode && rootEl.parentNode !== this.el) rootEl = rootEl.parentNode;
      rootEl.classList.toggle('hide', !wanted.includes(cardEl.dataset.type));
    });

    this.updateResultsCount();
  }

  renderedCallback() {
    if (!this.isCarousel) return;

    const swiperEl = this.el.closest('[data-swiper].swiper-initialized');
    if (!swiperEl) return;

    swiperEl.swiper?.destroy();
    window.loadSwiper();
  }

  async runQuery(query, variables, url = '/api/2025-07/graphql.json') {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': window.ymmConfig.apiKey,
      },
      body: JSON.stringify({query, variables}),
    })
    return await response.json()
  }

  updateMeta() {
    if (!window.vehicleMetaobject) return;
    this.metaDescriptionEls = this.metaDescriptionEls || document.querySelectorAll('[data-meta-description]');
    this.canonicalEl = this.canonicalEl || document.querySelector('[rel="canonical"]');
    this.metaTitleEl = this.metaTitleEl || document.querySelector('head title');
    this.metaImageEls = this.metaImageEls || document.querySelectorAll('[data-meta-image]');
    this.metaUrlEls = this.metaUrlEls || document.querySelectorAll('[data-meta-url]');
    this.metaOGTitleEls = this.metaOGTitleEls || document.querySelectorAll('[data-meta-title]');
    const part = this.partTypeParams.length === 1 ? this.partTypeParams[0].replaceAll('-', '_') : '';

    // Update URLs
    const url = `${location.origin}${location.pathname}?part_type=${this.partTypeParam}`;
    this.canonicalEl.href = url;
    this.metaUrlEls.forEach(el => el.content = url);

    if (!part) return;

    // Update Description
    const description = vehicleMetaobject[`${part}_seo_description`];
    if (description) this.metaDescriptionEls.forEach(el => el.content = description);

    // Update Image
    this.metaImages = document.querySelectorAll('[data-og-image]');
    this.metaImages.forEach(img => {
      if (img.dataset.part !== part) return;
      this.metaImageEls.forEach(el => el.content = img.dataset.ogImage || el.dataset.default);
    });

    // Update Title
    const title = vehicleMetaobject[`${part}_seo_title`];
    if (!title) return;
    const titleSuffix = this.metaTitleEl.dataset.suffix;
    const titleHandle = title.toLowerCase().replaceAll(' ', '-');
    const titleSuffixHandle = titleSuffix.toLowerCase().replaceAll(' ', '-');
    const suffix = titleHandle.includes(titleSuffixHandle) ? '' : titleSuffix;
    this.metaTitleEl.innerText = `${title}${suffix}`;
    this.metaOGTitleEls.forEach(el => el.content = `${title}${suffix}`);
  }

  updateResultsCount(count = null) {
    count = count || this.querySelectorAll('[data-product-card]:not(.hide)').length;
    if (this.ctEl) this.ctEl.innerHTML = count === 0 ? '<span class="no-results">Sorry no results</span>' : `${count} products`;
  }

  partTypeDisplayName(partTypes) {
    const tile = Array.from(document.querySelectorAll('[data-visual-filter-values]')).find(el => {
      const values = (el.dataset.visualFilterValues || '').split(',').filter(Boolean);
      return values.length === partTypes.length && values.every(value => partTypes.includes(value));
    });

    const label = tile?.querySelector('.visual-filters__label')?.textContent?.trim();
    return label || partTypes.map(partType => partType.replaceAll('-', ' ')).join(' & ');
  }

  updateVerifiedFitContent(partTypeParams) {
    const partTypes = partTypeParams || [];
    const hasPartTypes = partTypes.length > 0;
    const partTypeName = hasPartTypes ? this.partTypeDisplayName(partTypes) : '';

    this.verifiedFitEls = document.querySelectorAll('[data-verified-fit-el]');
    this.verifiedFitEls.forEach(el => {
      const fitBadgeQualifiedStatus = el.getAttribute('data-qualifiied-status') || 'qualified';
      const key = el.dataset.verifiedFitEl;
      const isFitBadge = key === 'fit-badge';
      const value = partTypeName || this.getVehicleDataValue(key);
      if (isFitBadge && !hasPartTypes) el.classList[fitBadgeQualifiedStatus === 'qualified' ? 'remove' : 'add']('js-hide');
      if (this.verified) {
        if (!value) {
          if (key === 'description' || key === 'media') {
            if (el.dataset.verifiedFitPart === this.getVehicleDataValue('part')) el.classList.remove('js-hide')
          }

          return
        }

        if (key === 'part') {
          el.innerText = value.replace('Performance Exhaust', 'Performance Exhaust Systems');
        } else {
          el.innerText = value;
        }
      } else if (hasPartTypes) {
        if (key === 'description' || key === 'media') {
          if (partTypes.includes(el.dataset.verifiedFitPart.toLowerCase().replaceAll(' ', '-'))) el.classList.remove('js-hide')
        }

        if (key === 'part') {
          el.innerText = partTypeName;
        }
      }
    });
  }
}

if (!customElements.get('vehicle-products')) {
  customElements.define('vehicle-products', VehicleProducts);
}